 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "scripts/client-legacy-" + ({"2":"vendors~AccountNewsletterContainerWithHydration~AlgoliaSearchContainerWithHydration~BillingAddressCo~a00dcaaa","3":"vendors~AccountNewsletterContainerWithHydration~AlgoliaSearchContainerWithHydration~BillingAddressCo~6f4ad0cd","4":"AccountNewsletterContainerWithHydration~ContactSellerMessageModalContainerWithHydration~ContactShopA~bc4927bc","5":"vendors~AlgoliaSearchContainerWithHydration~BillingAddressContainerWithHydration~CartWithHydration~C~d0146e0f","6":"AccountNewsletterContainerWithHydration~NotepadContentWithHydration~OffCanvasContainerWithHydration~~c0c3eb39","7":"vendors~AlgoliaSearchContainerWithHydration~LastActivityContainerwithHydration~MoreProductsWithHydration","8":"vendors~BillingAddressContainerWithHydration~CartWithHydration~CheckoutSPAWithHydration","11":"AccountNewsletterContainerWithHydration","12":"AlgoliaSearchContainerWithHydration","14":"BillingAddressContainerWithHydration","17":"CartWithHydration","19":"CheckoutSPAWithHydration","22":"ContactSellerMessageModalContainerWithHydration","23":"ContactShopApothekeModalContainerWithHydration","27":"LastActivityContainerwithHydration","30":"MessageThreadWithHydration","32":"MoreProductsWithHydration","36":"NewsletterFormContainerWithRender","38":"NewsletterUnsubscriptionWithHydration","40":"NotepadContentWithHydration","41":"OffCanvasContainerWithHydration","43":"OffersContainerWithHydration","47":"OrdersListContainerWithHydration","49":"ProductRatingsContainerWithHydration","50":"ProductVariantsContainerWithHydration","53":"SearchBoxContainerWithHydration","55":"SellerModalContainerWithRender","57":"SubscriptionClientContainerWithRender","59":"ThreadsListContainerWithHydration","61":"i18n-0","62":"i18n-1","63":"i18n-2","64":"i18n-3","65":"i18n-4","66":"i18n-5","67":"i18n-6","68":"vendors~ProductVariantsContainerWithHydration","69":"vendors~SearchBoxContainerWithHydration","70":"vendors~SellerModalContainerWithRender","71":"vendors~SubscriptionClientContainerWithRender"}[chunkId]||chunkId) + "-" + {"2":"8597d62be01268e2bbb4","3":"640df59833c714938029","4":"041ece0377901c27010a","5":"01b869afda398057d41d","6":"575ca0ecb070df64f992","7":"9ba8d7d815df156694e5","8":"1241c2c59b77cc0cb60c","11":"52c730e4df58848874fa","12":"dca2aad33ea31e6f1cb8","14":"bdcb5fff9e3c5185357c","17":"32c5a6df24b010fd3d7e","19":"954d813a93ccc590e62e","22":"d71e57d9249c7d923827","23":"a70964973710822bd335","27":"b1fe7657d8eb29d50fc6","30":"5db5bf0a399ac016513c","32":"349e4a4f38f162fc1411","36":"9c0cdfab308dbb6b7a50","38":"920791aa1da2a3ac76a8","40":"9278aa7435f267c9f0b2","41":"b6ddc4bb6f052057d8f7","43":"1ade09778028074d244d","47":"ad9a31ead82604a5cb75","49":"28c8b8c7dfd5b0883ce1","50":"9e12bb96513127482add","53":"a9c59f042a6d983ef00e","55":"69ba6b252b7a2292a30e","57":"bd3ae0480337845e7341","59":"0c57cf5295725f5546a2","61":"f551f8404965be7bc86d","62":"55b84b5710f2b049d34a","63":"0533d22b6b14f99d11cc","64":"8cfc5dd2e811e4be3143","65":"49adf141a12e7a70b326","66":"fddd0712994b40997eb9","67":"817cfc8b4ee3c5d85faf","68":"a4e59602974e071ffe69","69":"0a54a52aceaaab282089","70":"df9055f54739cc8f7c57","71":"b670fb9350fd01ec1b01"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
